import { FinishEnum } from "modules/cards/model/card";
import {
  finishLabel,
  primaryAvailableFinish,
} from "modules/cards/model/finishBehavior";

export function finishOptions(
  finishes: FinishEnum[]
): { value: FinishEnum; label: string }[] {
  return finishes.map((f) => ({ value: f, label: finishLabel(f) }));
}

// Keep a finish valid for a given printing: prefer the current pick, fall back
// to NonFoil, then to the first available. An empty list means "unknown" — keep
// the current value rather than blanking the control.
export function snapFinish(
  available: FinishEnum[],
  current: FinishEnum
): FinishEnum {
  if (available.length === 0 || available.includes(current)) return current;
  return primaryAvailableFinish(available) ?? current;
}
